import { ComponentPropsWithoutRef, ElementType, ReactElement } from "react";
import * as styles from "./Button.css";

export type ButtonProps = styles.ButtonVariants & {
  icons?: {
    iconPrimary: ReactElement;
    iconSecondary?: ReactElement;
  };
  disabled?: boolean;
  asChild?: boolean;
  layout?: "default" | "inverse";
};

export type InternalButtonProps = Omit<
  ComponentPropsWithoutRef<"button">,
  "asChild"
> &
  ButtonProps;

export const Button = ({
  isPrimary = true,
  theme = "light",
  icons,
  children,
  size = "md",
  layout = "default",
  disabled,
  asChild = false,
  ...props
}: InternalButtonProps) => {
  const Component = (asChild ? "div" : "button") as ElementType;

  return (
    <Component
      {...(asChild ? {} : { type: props.type || "button" })}
      className={styles.button({
        theme: theme,
        isPrimary: isPrimary,
        size: size,
        hasChild: children ? true : false,
        isDisabled: disabled,
        layout: layout,
      })}
      {...props}
    >
      <div
        className={styles.child({
          hasIcon: icons ? true : false,
          size: size,
          isPrimary: isPrimary,
          layout: layout,
        })}
      >
        {children}
        {icons && (
          <div className={styles.iconsContainer({ size: size })}>
            <div className={styles.icons}>
              <div className={styles.iconContainer({ size: size })}>
                <div
                  className={styles.icon({
                    size: size,
                    hasChild: children ? true : false,
                  })}
                >
                  {icons.iconPrimary}
                </div>
              </div>
              <div className={styles.iconContainer({ size: size })}>
                <div
                  className={styles.icon({
                    size: size,
                    hasChild: children ? true : false,
                  })}
                >
                  {icons.iconSecondary || icons.iconPrimary}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Component>
  );
};
